<div class="admin-layout" [class.sidebar-collapsed]="!sidebarOpen">
  @if (isMobileMenuOpen) {
    <div class="mobile-overlay" (click)="closeMobileMenu()"></div>
  }

  <app-sidebar
    [isOpen]="sidebarOpen"
    [isMobileOpen]="isMobileMenuOpen"
    (closeMobile)="closeMobileMenu()">
  </app-sidebar>

  <div class="admin-layout-main">
    <!-- Mobile : le bouton suit le menu mobile (fermé par défaut), pas le menu ordinateur (30/10/2026). -->
    <app-header [isMenuOpen]="isMobile ? isMobileMenuOpen : sidebarOpen" (toggleSidebar)="toggleSidebar()"></app-header>

    <main class="admin-main-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
<app-modal-container></app-modal-container>
<pkg-delete-confirm-pop-in-host></pkg-delete-confirm-pop-in-host>
<notification></notification>
